import { track } from '@farmersdog/analytics';

import { segmentTrackEvents } from '../segmentTrackEventNames';
import { AnalyticsSite } from '../types';

export function trackClicked({
  module_name,
  component,
  text,
  checked,
}: {
  module_name: string;
  component: string;
  text?: string;
  checked?: boolean;
}) {
  track(segmentTrackEvents.clicked, {
    site: AnalyticsSite.Main,
    component,
    module_name,
    text,
    checked,
  });
}
